import { useCallback, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import queryString from 'query-string';
import { $auth } from 'ziphy-web-shared/basic/entities/auth';
import { isUrl } from 'ziphy-web-shared/basic/helpers';
import { $router } from 'ziphy-web-shared/basic/utils/router';
import { $configure } from '@library/plugins/configure/configure.store';
export function useLoginForm({ redirectAfterComplete, waitAllConfigureSteps, _core, }) {
    const location = useLocation();
    const { referrer } = queryString.parse(location.search);
    const handleComplete = useCallback(() => {
        if (!$auth.isLogged || (waitAllConfigureSteps && $configure.hasRequired))
            return;
        let successUrl = redirectAfterComplete;
        if (referrer) {
            const url = Array.isArray(referrer) ? referrer[0] : referrer;
            if (isUrl(url)) {
                successUrl = { href: url };
            }
            else {
                successUrl = { to: $router.toPath(url) };
            }
        }
        if (successUrl) {
            $router.executeAutoTarget(successUrl);
        }
        _core === null || _core === void 0 ? void 0 : _core.onUnblock();
        _core === null || _core === void 0 ? void 0 : _core.onHide();
    }, [$auth.isLogged, $configure.hasRequired]);
    useEffect(handleComplete, [handleComplete]);
    return {
        referrer,
        handleOnComplete: handleComplete,
    };
}
